export const PARTNER_BY_PATH_ENDPOINT = '/graphql/execute.json/yme/getPartnerByPath;path=';
